import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PaceCoreModule } from '@evorait/pace-core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ClipboardModule } from 'ngx-clipboard';
import { CalibrationDateComponent } from './components/calibration-date/calibration-date.component';
import { CancellationComponent } from './components/cancellation/cancellation.component';
import { ErrorLogComponent } from './components/error-log/error-log.component';
import { EtaAlertComponent } from './components/eta-alert/eta-alert.component';
import { ExpensesListComponent } from './components/expenses-list/expenses-list.component';
import { MeasurementToolsComponent } from './components/measurement-tools/measurement-tools.component';
import { NotificationStatusBadgeComponent } from './components/notification-status-badge/notification-status-badge.component';
import { RecipientListComponent } from './components/recipient-list/recipient-list.component';
import { RequestNotificationComponent } from './components/request-notification/request-notification.component';
import { SwipeDirective } from './directives/swipe.directive';

@NgModule({
    declarations: [
        CancellationComponent,
        RequestNotificationComponent,
        NotificationStatusBadgeComponent,
        RecipientListComponent,
        ExpensesListComponent,
        ErrorLogComponent,
        EtaAlertComponent,
        CalibrationDateComponent,
        MeasurementToolsComponent,
        SwipeDirective,
    ],
    exports: [
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        ProgressbarModule,
        BsDropdownModule,
        AccordionModule,
        ModalModule,
        TabsModule,
        FontAwesomeModule,
        // TreeModule,
        CarouselModule,
        CancellationComponent,
        RequestNotificationComponent,
        NotificationStatusBadgeComponent,
        RecipientListComponent,
        ExpensesListComponent,
        ErrorLogComponent,
        EtaAlertComponent,
        SwipeDirective,
    ],
    imports: [
        PaceCoreModule.forChild(),
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        ProgressbarModule,
        ModalModule,
        BsDropdownModule,
        AccordionModule,
        TabsModule,
        FontAwesomeModule,

        CarouselModule,
        RouterModule,
        ClipboardModule,
    ],
})
export class SharedModule {}
